import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FC, PropsWithChildren } from 'react';

import { Image } from 'src/components/image';
import { exclamationMarkProps } from 'src/resources/images';

import { StyledMessage, StyledMessageContainer } from './card-error-message.styled';

export const CardErrorMessage: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return (
    <StyledMessageContainer>
      <Image {...exclamationMarkProps} />
      <StyledMessage variant="uiText3" component="p" maxBreakpoint={Breakpoint.TABLET}>
        {children}
      </StyledMessage>
    </StyledMessageContainer>
  );
};
